import { useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState("");

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast("复制失败，请手动复制浏览器地址");
    }
    setTimeout(() => setToast(""), 2200);
  };

  const url = window.location.href;
  const encode = (v: string) => encodeURIComponent(v);

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 p-4">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
        <i className="ri-share-line text-base text-primary-700"></i>
        分享这部影片
      </h3>
      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={copyLink}
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-link"></i>
          复制链接
        </button>
        <a
          href={`https://911zyheji.asia/share/share.php?url=${encode(url)}&title=${encode(title)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-weibo-fill"></i>
          微博
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${encode(url)}&text=${encode(title)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-twitter-x-fill"></i>
          X
        </a>
      </div>
      {toast && (
        <div className="mt-3 animate-fade-in rounded-md bg-primary-950 px-3 py-2 text-xs font-medium text-background-50">
          <i className="ri-checkbox-circle-line mr-1 text-accent-300"></i>
          {toast}
        </div>
      )}
    </div>
  );
}